<template>
	<button
		type="button"
		class="quick-action"
		:class="{
			'quick-action--disabled': disabled,
		}"
		:disabled="disabled"
		@click="emit('click')"
	>
		<SuiIcon :name="iconName" />

		{{ title }}
	</button>
</template>

<script setup lang="ts">
import { SuiIcon } from '@developers/scoro-ui';

defineProps<{
	disabled?: boolean;
	title: string;
	iconName: string;
}>();

const emit = defineEmits<{
	(e: 'click'): void;
}>();
</script>

<style scoped lang="scss">
.quick-action {
	position: relative;
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.875rem 2rem;

	&:hover {
		background: $neutral-20;
		color: inherit;
	}

	&--disabled {
		opacity: 0.5;
	}
}
</style>
